import type { CSSProperties } from 'react';

function mixChannel(from: number, to: number, t: number): number {
  return Math.round(from + (to - from) * t);
}

function mixRgb(
  from: [number, number, number],
  to: [number, number, number],
  t: number
): string {
  return `rgb(${mixChannel(from[0], to[0], t)}, ${mixChannel(from[1], to[1], t)}, ${mixChannel(from[2], to[2], t)})`;
}

/** Degradé rojo → gris: tasa más alta → rojo; más baja → gris claro. */
export function getCydRateGrayBadgeStyle(
  value: number,
  minRate: number,
  maxRate: number
): CSSProperties {
  if (!Number.isFinite(value)) {
    return {
      backgroundColor: '#eef1f3',
      color: '#6b7280',
    };
  }

  const t = maxRate === minRate ? 1 : (value - minRate) / (maxRate - minRate);
  const clamped = Math.min(1, Math.max(0, t));

  const backgroundColor = mixRgb([238, 241, 243], [253, 236, 234], clamped);
  const color = mixRgb([107, 114, 128], [185, 28, 28], clamped);

  return { backgroundColor, color };
}

export function getCydRateRange(rows: Array<{ cyd_rate?: unknown }>): {
  min: number;
  max: number;
} | null {
  const rates = rows
    .map((row) => parseFloat(String(row.cyd_rate ?? '')))
    .filter((rate) => Number.isFinite(rate));

  if (rates.length === 0) {
    return null;
  }

  return {
    min: Math.min(...rates),
    max: Math.max(...rates),
  };
}
